import React from "react";

import { useMutation, useQuery } from "@apollo/client";
import { useRouteMatch } from "react-router-dom";

import RbGrid from "components/RbGrid";
import RbTextField from "components/RbTextField";
import {
  createManufacturerMutation,
  updateManufacturerMutation,
  manufacturerQuery,
  manufacturerListQuery,
} from "graphql/manufacturer";
import { createSortByProp } from "utils/sortUtils";

import BaseForm from "./BaseForm";

function ManufacturerForm() {
  const { path } = useRouteMatch();
  const match = useRouteMatch(`${path}/:idParam`);
  const idParam = match?.params?.idParam;

  const { data: { manufacturer } = {} } = useQuery(manufacturerQuery, {
    variables: {
      id: idParam,
    },
    skip: !idParam || idParam === "new",
  });

  const [createRow] = useMutation(createManufacturerMutation, {
    update(cache, result) {
      const { manufacturerList } = cache.readQuery({
        query: manufacturerListQuery,
      });
      const data = {
        manufacturerList: [
          result.data.createManufacturer,
          ...manufacturerList,
        ].sort(createSortByProp("name")),
      };
      cache.writeQuery({
        query: manufacturerListQuery,
        data,
      });
    },
  });

  const [updateRow] = useMutation(updateManufacturerMutation);

  return (
    <BaseForm
      row={manufacturer}
      createPromise={createRow}
      updatePromise={updateRow}
      title="manufacturer"
    >
      <RbGrid item xs={12}>
        <RbTextField fieldName="name" label="Name" required />
      </RbGrid>
    </BaseForm>
  );
}

export default React.memo(ManufacturerForm);
